<template>
	<section class="section mis-quinielas">
		<!-- <h1 class="title is-3"><font-awesome-icon icon="check-square" /> Mis quinielas</h1> -->

		<p v-if="mis_quinielas.length == 0">No tienes quinielas</p>
		
		<QuinielasList titulo="Mis Quinielas" :quinielas="mis_quinielas" :user="user.user" />

		<div class="has-text-centered" v-if="mis_quinielas.length < user.user.quinielas_total">
			<button class="button" :class="{'is-loading' : loadingBtn}" @click.prevent="cargarMas()">Cargar mas..</button>
		</div>

	</section>
</template>

<script>
	import { mapState } from 'vuex'
	import QuinielasList from '@/components/QuinielasList'

	export default {
		components: { QuinielasList },
		name: 'MisQuinielas',

		data() {
			return {
				loadingBtn: false
			};
		},
		computed: {
			...mapState('quinielas',['mis_quinielas']),
			...mapState('user', ['user'])
		},
		methods:{
			cargarMas(){
				this.loadingBtn = true
				
				this.$store.dispatch('quinielas/fetchMisQuinielas',{cant: this.mis_quinielas.length})
				.then(() =>{
					this.loadingBtn = false
				})
			}
		},
		created(){
			if (this.mis_quinielas.length == 0) {
				this.$store.dispatch('quinielas/fetchMisQuinielas')
			}
		},
		metaInfo(){
			return {
				title: 'Mis quinielas | Quinielazo.com'
			}
		}
	};
</script>

<style lang="css" scoped>
.mis-quinielas{
	padding: 1rem 1rem;
	min-height: 300px;
}
</style>
